module.exports = __webpack_public_path__ + "img/banner-store-image.ce9c4430.webp";